<template>
  <div class="subscription-card">
    <img :src="company.urlOfLogo" class="company-logo" alt="Logo" />
    <div class="company-info">
      <h3 class="company-name">{{ company.name }}</h3>
      <p class="company-description">{{ truncatedDescription }}</p>
    </div>
    <button class="remove-button" @click="$emit('unsubscribe', company.id)">
      <img src="../assets/chat-decline-icon.png" alt="Удалить" class="remove-icon" />
    </button>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';

const { company } = defineProps({
  company: Object
});

const truncatedDescription = computed(() => {
  return company.aboutCompany?.slice(0, 90) + '...';
});

onMounted(() => {
  console.log("📦 company prop:", company);
});
</script>

<style scoped>

.subscription-card {
  display: flex;
  align-items: center;
  background-color: #f7f7f7;
  border-radius: 20px;
  padding: 20px;
  width: 400px;
  position: relative;
  gap: 20px;
  height: 100px;
  transition: all 0.2s ease;
}

[data-theme="dark"] .subscription-card {
  background-color: #2b2b2b;
}

.subscription-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  cursor: default;
}

[data-theme="dark"] .subscription-card:hover {
  box-shadow: 0 6px 12px rgba(255, 255, 255, 0.05);
}

.company-logo {
  width: 60px;
  height: 60px;
  border-radius: 100px;
  object-fit: cover;
}

.company-info {
  flex: 1;
}

.company-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}

.company-description {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  margin-right: 40px;
}

.remove-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  margin-right: 60px;
}

.remove-icon {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.remove-button:hover .remove-icon {
  filter: brightness(0.8);
  transform: scale(1.05);
  transition: all 0.2s ease;
}

[data-theme="dark"] .company-name {
  color: #fff;
}

[data-theme="dark"] .company-description {
  color: #ccc;
}

@media (max-width: 430px) {

.subscription-card {
  width: 100%;
  min-height: 96px;
  height: auto;

  padding: 14px;

  gap: 12px;

  border-radius: 18px;

  align-items: flex-start;

  box-sizing: border-box;
}

.company-logo {
  width: 52px;
  height: 52px;

  flex-shrink: 0;
}

.company-info {
  flex: 1;
  min-width: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.company-name {
  font-size: 14px;
  line-height: 1.25;

  margin-bottom: 6px;

  word-break: break-word;
}

.company-description {
  margin-right: 0;

  font-size: 12px;
  line-height: 1.45;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;
}

.remove-button {
  width: 34px;
  height: 34px;

  margin: 0;

  align-self: center;

  flex-shrink: 0;
}

.remove-icon {
  width: 24px;
  height: 24px;
}

.subscription-card:hover {
  transform: none;
}
}

</style>